import React, { HTMLProps } from 'react';

const Header = (props: HTMLProps<HTMLDivElement>) => (
  <div className="md:px-2 py-4 w-full flex justify-between bg-white" {...props} />
);

export default Header;
